import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoyaltyForMemberFreeProductsModule } from './forMemberFreeProducts';
import { LoyaltyForMemberProgramProductsModule } from './forMemberProgramProducts';
import { LoyaltyForMemberRewardsModule } from './forMemberRewards';
import { LoyaltyForPromotionModule } from './forPromotion';

const toExport: any[] = [
    LoyaltyForMemberFreeProductsModule,
    LoyaltyForMemberProgramProductsModule,
    LoyaltyForMemberRewardsModule,
    LoyaltyForPromotionModule,
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        ...toExport
    ],
    providers: [],
})
export class LoyaltyTypesModule { }
